import RadioGroup from "../../../components/inputs/radio-group/radio-group";
import useInput from "../hooks/use-input";
import { useFormContext } from "../contexts/form-context";
import { useLayoutEffect, useEffect } from "react";
import { useTranslate } from "../../translation/hooks/use-translation";

const FormRadioGroup = (props) => {
  const { ref, bind } = useInput(props);

  const { register, deregister, updateValidity } = useFormContext();
  const { getTranslatedProps } = useTranslate();

  const {
    translatedLabel,
    translatedOptions = [],
  } = getTranslatedProps(props);

  useLayoutEffect(() => {
    if (!props.ignore) {
      // Register as ref in form on mount
      register(props.id || props.name, ref);

      // Deregister as ref in form on unmount
      return () => {
        deregister(props.id || props.name);
      };
    }
  }, []);

  useEffect(() => {
    updateValidity(props.name, bind.error);
  }, [bind.error]);

  return (
    <RadioGroup
      {...props}
      {...bind}
      label={translatedLabel}
      options={translatedOptions}
    />
  );
};

export default FormRadioGroup;
